import { RouteObject } from "react-router-dom";
import AdminDashboard from "./AdminDashboard";
import SubscribePage from "./subscription/SubscribePage";
import PageNotFoundPage from "./PageNotFoundPage";
import MyOrdersPage from "./off-taker/order/MyOrdersPage";
import OffTakerDashboard from "./off-taker/OffTakerDashboard";
import MyOrderDetailPage from "./off-taker/order/MyOrderDetailPage";
import CreateOrderPage from "./off-taker/order/CreateOrderPage";
import DocumentsPage from "./DocumentsPage";
import ProductsPage from "./products/ProductsPage";
import ProductsDetailPage from "./products/ProductsDetailPage";
import OrderDetailPage from "./order/OrderDetailPage";
import OrderPage from "./order/OrderPage";
import OrganizationDetailPage from "./organizations/OrganizationDetailPage";
import OrganizationsPage from "./organizations/OrganizationsPage";
import InputPage from "./inputs/InputPage";
import UsersPage from "./users/UsersPage";
import UserDetailPage from "./users/userDetailPage";
import AllUsersPage from "./users/AllUsersPage";
import ProfilePage from "../pages/users/Profile";
import ChangePassword from "./users/ChangePassword";
import AgroDealerDashboard from "./agro-dealer/AgroDealerDashboard";
import VoucherDetail from "./agro-dealer/VoucherDetail";
import VoucherPage from "./agro-dealer/VoucherPage";
import AmfiDashboard from "./amfi/AmfiDashboard";
import WareHousePage from "./admin/WareHousePage";
import AgronomyPage from "./admin/AgronomyPage";
import LookupPage from "./admin/LookupPage";
import InputPricePage from "./admin/InputPricePage";
import OutputPricePage from "./admin/OutputPricePage";
import BranchesPage from "./BranchesPage";
import BranchDetailPage from "./BranchDetailPage";
import ContractsPage from "./contract/ContractsPage";
import CustomerPage from "./customer/CustomerPage";
import CustomerDetailPage from "./customer/CustomerDetailPage";
import ContractDetailPage from "./contract/ContractDetailPage";
import InputSalesPage from "./agro-dealer/InputSale";
import RedemptionPage from "./agro-dealer/RedemptionPage";
import SuperAdminPage from "./admin/SuperAdminPage";
import RedemptionsPage from "./RedemptionsPage";
import ImportCustomers from "./customer/ImportCustomers";
import WorkLocationPage from "./admin/WorkLocationPage";
import AddressPage from "./AddressPage";
import UnionPage from "./UnionPage";
import PrePlantingPage from "./scouting/PrePlantingPage";
import PlantingPage from "./scouting/PlantingPage";
import PreHarvestingPage from "./scouting/PreHarvestingPage";
import PlantGrowthPage from "./scouting/PlantGrowthPage";
import NonContractFarmerDetailPage from "./customer/NonContractFarmerDetailPage";
import AIDataIngestionPage from "./AIDataIngestionPage";
import CreditScoringPage from "./CreditScoringPage";
import FarmingStagePage from "./admin/FarmingStagePage";
import PlantingDetailPage from "./scouting/PlantingDetailPage";
import PrePlantingDetailPage from "./scouting/PrePlantingDetailPage";
import PlantGrowthDetailPage from "./scouting/PlantGrowthDetailPage";
import HomePage from "./HomePage";
import BanksPage from "./admin/BanksPage";
import LoanConfigPage from "./admin/LoanConfigPage";
import UnitOfMeasurementPage from "./admin/UnitOfMeasurementPage";

const sharedRoutes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:id",
    element: <ProductsDetailPage />,
  },
  {
    path: "/agronomy/products",
    element: <ProductsPage />,
  },
  {
    path: "/agronomy/products/:id",
    element: <ProductsDetailPage />,
  },
  {
    path: "/subscribe/:orgType",
    element: <SubscribePage />,
  },
  {
    path: "/subscribe",
    element: <SubscribePage />,
  },
  {
    path: "/users",
    element: <UsersPage />,
  },
  {
    path: "/users/:id",
    element: <UserDetailPage />,
  },
  {
    path: "/all-users/:id",
    element: <UserDetailPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "/changePassword",
    element: <ChangePassword />,
  },
  {
    path: "/branches",
    element: <BranchesPage />,
  },
  {
    path: "/branches/:id",
    element: <BranchDetailPage />,
  },
  //   {
  //     path: "/resetPassword",
  //     element: <ResetPassword />
  //   },
];

const ownerRoutes: RouteObject[] = [
  {
    path: "/sp-admin",
    element: <SuperAdminPage />,
  },
];

const supperAdminRoutes: RouteObject[] = [
  {
    path: "/agronomy/index",
    element: <AgronomyPage />,
  },
  {
    path: "/lookup/index",
    element: <LookupPage />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
  },
  {
    path: "/orders",
    element: <OrderPage />,
  },
  {
    path: "/orders/:id",
    element: <OrderDetailPage />,
  },
  {
    path: "/agronomy/inputs",
    element: <InputPage />,
  },
  {
    path: "/all-users",
    element: <AllUsersPage />,
  },
  {
    path: "/organizations",
    element: <OrganizationsPage />,
  },
  {
    path: "/organizations/:id",
    element: <OrganizationDetailPage />,
  },
  {
    path: "/warehouse",
    element: <WareHousePage />,
  },
  {
    path: "/customers",
    element: <CustomerPage />,
  },
  {
    path: "/importCustomers",
    element: <ImportCustomers />,
  },
  {
    path: "/workLocations",
    element: <WorkLocationPage />,
  },
  {
    path: "/customers/:id",
    element: <CustomerDetailPage />,
  },
  {
    path: "/customers/non-contract-farmers/:id",
    element: <NonContractFarmerDetailPage />,
  },
  {
    path: "/agronomy/farming-stage",
    element: <FarmingStagePage />,
  },
  {
    path: "/settings/input-price",
    element: <InputPricePage />,
  },
  {
    path: "/settings/output-price",
    element: <OutputPricePage />,
  },
  {
    path: "/lookup/address",
    element: <AddressPage />,
  },
  {
    path: "/lookup/unions",
    element: <UnionPage />,
  },
  {
    path: "/lookup/unit-of-measurement",
    element: <UnitOfMeasurementPage />,
  },
  {
    path: "/ai/data-ingestion",
    element: <AIDataIngestionPage />,
  },
  {
    path: "/ai/credit-scoring",
    element: <CreditScoringPage />,
  },
  {
    path: "/banking/banks",
    element: <BanksPage />,
  },
  {
    path: "/banking/loan-configs",
    element: <LoanConfigPage />,
  },
];

const offTakerRoutes: RouteObject[] = [
  {
    path: "/off-taker",
    element: <OffTakerDashboard />,
  },
  {
    path: "/my-orders",
    element: <MyOrdersPage />,
  },
  {
    path: "/my-orders/:id",
    element: <MyOrderDetailPage />,
  },
  {
    path: "/create-order",
    element: <CreateOrderPage />,
  },
  {
    path: "/edit-order/:id",
    element: <CreateOrderPage />,
  },
  {
    path: "/documents",
    element: <DocumentsPage />,
  },
  {
    path: "/scouting/pre-planting",
    element: <PrePlantingPage />,
  },
  {
    path: "/scouting/pre-planting/:id",
    element: <PrePlantingDetailPage />,
  },
  {
    path: "/scouting/planting",
    element: <PlantingPage />,
  },
  {
    path: "/scouting/planting/:id",
    element: <PlantingDetailPage />,
  },
  {
    path: "/scouting/pre-harvest",
    element: <PreHarvestingPage />,
  },
  {
    path: "/scouting/plant-growth",
    element: <PlantGrowthPage />,
  },
  {
    path: "/scouting/plant-growth/:id",
    element: <PlantGrowthDetailPage />,
  },
];

const agroDealerRoutes: RouteObject[] = [
  {
    path: "/ad-dashboard",
    element: <AgroDealerDashboard />,
  },
  {
    path: "/redemption",
    element: <RedemptionPage />,
  },
  {
    path: "/redemptions",
    element: <RedemptionsPage />,
  },
  {
    path: "/voucher",
    element: <VoucherPage />,
  },
  {
    path: "/voucher/:id",
    element: <VoucherDetail />,
  },
  {
    path: "/agro_dealer",
    element: <DocumentsPage />,
  },
  {
    path: "/input-sales",
    element: <InputSalesPage />,
  },
];

const bankRoutes: RouteObject[] = [
  {
    path: "/mfi",
    element: <AmfiDashboard />,
  },
  {
    path: "/organization",
    element: <OrganizationDetailPage />,
  },
  {
    path: "/contracts",
    element: <ContractsPage />,
  },
  {
    path: "/contracts/:id",
    element: <ContractDetailPage />,
  },
];

const insuranceRoutes: RouteObject[] = [
  //   {
  //     path: "/insurance",
  //     element: <InsuranceDashboardPage />
  //   },
  //   {
  //     path: "/contracts",
  //     element: <ContractsPage />
  //   },
  //   {
  //     path: "/contracts/:id",
  //     element: <ContractDetailPage />
  //   },
];

const routes: RouteObject[] = [
  ...sharedRoutes,
  ...supperAdminRoutes,
  ...offTakerRoutes,
  ...bankRoutes,
  ...insuranceRoutes,
  ...agroDealerRoutes,
  ...ownerRoutes,
  {
    path: "*",
    element: <PageNotFoundPage />,
  },
];

export default routes;
